<template>
  <div class="success">
    <img
      :src="images.tick"
      alt="success"
      aria-hidden="true"
    >
    <h3 class="h3">{{ successPage.title }}</h3>
    <p
      v-for="(copy,index) in successPage.copy"
      :key="index"
      class="p">{{ copy }}
    </p>
    <module-button
      button="primary"
      :link="successPage.buttonLink"
      :label="successPage.buttonLabel"
    />
  </div>
</template>

<script>
// Modules
import ModuleButton from 'modules/Button';

// Image
const images = {
  tick: require(`images/dashboard/success-tick.svg`),
};

export default {
  name: `module-success`,

  // Components
  components: {
    ModuleButton,
  },

  // Props
  props: {
    successPage: Object,
  },

  data() {
    return {
      images,
    };
  },
};
</script>



// WEBPACK FOOTER //
// Success.vue?742aad64